import type { NestedLevelProps } from '../../types/filter-list';
import styles from './NestedLevel.module.scss';

export default function NestedLevel({
  level,
  canEdit,
  renderContent,
}: NestedLevelProps) {
  return (
    <div className={styles.nestedLevel}>
      <div className={styles.nestedLevelTitle}>
        Level
        {' '}
        {level.level + 1}
        <span className={styles.nestedLevelOperator}>
          (
          {level.operator}
          )
        </span>
      </div>
      {renderContent({
        filters: level.criteria.filter((item) => item.type !== 'level'),
        operator: level.operator,
        canEdit,
      })}
    </div>
  );
}
